import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Form from 'react-bootstrap/Form';
import { Col, Row } from "react-bootstrap";
import stripNonLatin1 from '../../utils/sanitization/stripNonLatin1';

class ValidatedTextField extends Component{
  constructor(props){
    super(props);
    this.state= {
      validated: this.props.isValidated,
    };
    this.onTextChange = this.onTextChange.bind(this);

  }

  onTextChange(event){
    //getting field name and value
    const fieldName = event.target.name;
    const sanitizedValue = stripNonLatin1(event.target.value);

    this.props.onChange(fieldName, sanitizedValue);
  }

  render() {
    const { textType, textName, labelID, index, content, limitFromRules} = this.props;
    return(
      <Row>
          <Col xs={3} md={2}>
        {
          labelID ? <b><FormattedMessage id={labelID}/> {index >= 0 ? index + 1 : ""}</b> : ''
        }
        </Col>
          <Col xs={9} md={10}>
        <Form validated={this.props.isValidated}>
          <Form.Group controlId={"validation" + textName} >
            <Form.Control
              required
              type={textType === "int" ? "number" : textType}
              name={textName} 
              onChange={(e) => {
                const value = e.target.value;
                if (textType === "int" && (value.includes(".") || value.includes("-"))) {
                  e.target.value = value.replace(/[^\d]/g, '');
                }
                this.onTextChange(e);
              }}
              value={this.props.content}
              maxLength={typeof limitFromRules != 'undefined' && limitFromRules !== null ? limitFromRules : ""}
              min={textType === "int" ? 0 : undefined}
            />
            {
              limitFromRules ? <small style={content ? content.length > limitFromRules ? {color: "red"} : {} : {}}>{content ? content.length : 0} / {limitFromRules}</small> : ""
            }
          </Form.Group>
        </Form>

        </Col>
      </Row>
    );
  }
}

export default ValidatedTextField;